/** @format */

/* eslint-disable */
import React, { useState } from 'react'
import Swal from 'sweetalert2'
import BreadCrumb from '../../../../../Components/BreadCrumb/Index'
import ListLoanDisbursement from '../../../../../Components/ReUsables/LoanDisbursement/ListLoanDisbursement'
import localize from '../../../../../Global/Localize'
import {
  BatchAuditOption,
  batchStatus,
} from '../../../../../Global/enumeration'
import { postData } from '../../../../../Helpers/webApi'
import { GlobalValidationErrors } from '../../../../../Validation/ValidationState'
import AuthorizeLoanBatch from './AuthorizeLoanBatch/AuthorizeLoanBatch'
import { showNotification } from '../../../../../Helpers/Notification/ShowNotification'

const BatchAuthorization = () => {
  const [mode, setMode] = useState(null)
  const [isAuthorize, setIsVerify] = useState(false)
  const [reload, setReload] = useState(false)
  const [isBusy, setIsBusy] = useState(false)
  const [loan, setLoan] = useState({
    batchAuditOption: Object.keys(BatchAuditOption)[0],
  })
  const [globalValidationErrors, setGlobalValidationErrors] =
    GlobalValidationErrors.use()

  const handleClose = () => {
    setMode(null)
    setLoan({
      batchAuditOption: Object.keys(BatchAuditOption)[0],
    })
    setIsVerify(false)
  }

  const handleSelectAuthBatch = batch => {
    if (batch.isLocked)
      return Swal.fire({
        icon: 'error',
        title: 'Operation not allowed!',
        text: 'This batch is already locked!',
      })

    if (batch.status !== Object.keys(batchStatus)[3])
      return Swal.fire({
        icon: 'error',
        title: 'Operation not allowed!',
        text: `This batch is must be in Audited status!`,
      })

    setMode('authorize')
    setLoan({
      ...batch,
      batchAuditOption: Object.keys(BatchAuditOption)[0],
    })
    setIsVerify(true)
  }

  const clearValidation = column => {
    setGlobalValidationErrors(g => {
      delete g[column]
      return g
    })
  }

  const handleAuthorizeBatch = async () => {
    if (!loan.authorizationRemarks) {
      return GlobalValidationErrors.set({
        AuthorizationRemarks: {
          message: 'Authorization Remarks is required!',
        },
      })
    }

    setIsBusy(true)

    const url = '/LoanDisbursementBatch/authorize-loan-disbursement-batch'

    const { success } = await postData(
      url,
      {
        loanDisbursementBatch: loan,
        batchAuthOption: loan.batchAuditOption,
      },
      false
    )

    if (success) {
      handleClose()
      setReload(true)
      showNotification("Loan Disbursement Batch's Authorization", 'success')
    }

    setIsBusy(false)
  }

  return (
    <>
      <BreadCrumb
        tree={[
          localize('creditManagement'),
          localize('loanDisbursement'),
          localize('batchAuthorization'),
        ]}
      />
      {mode === 'authorize' && (
        <AuthorizeLoanBatch
          loan={loan}
          handleClose={handleClose}
          mode={mode}
          handleAuthorizeBatch={handleAuthorizeBatch}
          globalValidationErrors={globalValidationErrors}
          clearValidation={clearValidation}
          setLoan={setLoan}
          isBusy={isBusy}
        />
      )}

      <div className="card bg-white rounded">
        <div className="card-body">
          <ListLoanDisbursement
            showAuthorize
            hiddenColumns={[0]}
            handleSelectAuthBatch={handleSelectAuthBatch}
            isCreation={isAuthorize}
            status={Object.keys(batchStatus)[3]}
            reload={reload}
            setReload={setReload}
          />
        </div>
      </div>
    </>
  )
}

export default BatchAuthorization
